import { GameLayer } from "../../../lib/gamemap/GameLayer";
import { Transportation } from "../../../lib/runescape/transportation";
import { TransportData } from "../../../data/transports";
import { EntityTransportEntity } from "./entities/EntityTransportEntity";
import { TeleportSpotEntity } from "./entities/TeleportSpotEntity";
import { deps } from "../../dependencies";
import { TeleportAccessEntity } from "./entities/TeleportAccessEntity";
import { RemoteEntityTransportTarget } from "./entities/RemoteEntityTransportTarget";
var TeleportGroup = Transportation.TeleportGroup;
var EntityTransportation = Transportation.EntityTransportation;
export default class TransportLayer extends GameLayer {
    constructor(interactive, config = {
        teleport_policy: "all",
        transport_policy: "all"
    }) {
        super();
        this.teleports = [];
        if (config.teleport_policy != "none") {
            deps().app.settings.active_teleport_customization.subscribe(customization => {
                this.eachEntity(e => {
                    if (e instanceof TeleportSpotEntity) {
                        e.teleport.refresh();
                        e.render(true);
                    }
                });
            }, false, e => this.lifetime_manager.bind(e));
        }
        TransportData.getAll().then(transports => transports.forEach(trans => {
            switch (trans.type) {
                case "entity":
                case "door":
                    if (config.transport_policy != "all")
                        break;
                    new EntityTransportEntity(trans)
                        .setInteractive(interactive).addTo(this);
                    if (trans.type == "entity") {
                        trans.actions.forEach(action => {
                            action.movement.forEach(movement => {
                                if (!EntityTransportation.Movement.isLocal(movement)) {
                                    new RemoteEntityTransportTarget(trans, action, movement)
                                        .setInteractive(interactive).addTo(this);
                                }
                            });
                        });
                    }
                    break;
                case "teleports":
                    if (config.teleport_policy == "none")
                        break;
                    trans.spots
                        .forEach(spot => {
                        const s = new TeleportGroup.Spot(trans, spot, undefined);
                        if (s.props.hidden)
                            return;
                        this.teleports.push(new TeleportSpotEntity(new TeleportGroup.Spot(trans, spot, undefined))
                            .setInteractive(interactive)
                            .addTo(this));
                    });
                    if (config.teleport_policy != "target_only") {
                        trans.access.forEach(access => {
                            if (access.type == "entity") {
                                new TeleportAccessEntity(trans, access)
                                    .setInteractive(interactive)
                                    .addTo(this);
                            }
                        });
                    }
                    break;
            }
        }));
        this.quad_tree_debug_rendering = false;
    }
    getTeleportSpots() {
        return this.teleports.map(e => e.teleport);
    }
}
